import React from "react";

import preferences from "@/services/preferences";
import {IDeviceId} from "@toolbox/models";
import {ICycleDuration, ICycleModel} from "../models";

import Card from "@toolbox/design/Card";
import {
    hasLightFactor,
    hasRotation,
    hasTemperatureControl,
    hasTilt,
} from "@toolbox/functions/device-check";
import T from "@translate/T";
import Cycle from "./Cycle";

interface ICyclesProps {
    device: IDeviceId;
    durations: ICycleDuration[];
    cycles: ICycleModel[];
}

class Cycles extends React.PureComponent<ICyclesProps> {
    private unsubscribe?: () => void;

    public componentDidMount() {
        this.unsubscribe = preferences.subscribe({
            preferencesChanged: (_, changes) => {
                if (changes.includes("deviceConnections")) {
                    this.forceUpdate();
                }
            },
        });
    }

    public componentWillUnmount() {
        this.unsubscribe?.();
    }

    public render() {
        const {device} = this.props;
        const _hasRotation = hasRotation(device.deviceClass);
        const _hasLightFactor = hasLightFactor(device.deviceClass);
        const _hasTilt = hasTilt(device.deviceClass);
        const _hasTemp = hasTemperatureControl(device);

        return (
            <Card headerClassName="bg-secondary" title={<T>Cycles</T>}>
                <table className="table table-sm table-striped table-right table-borderless">
                    <thead>
                        <tr>
                            <th>
                                <T>Start</T>
                            </th>
                            <th>
                                <T>Profiles</T>
                            </th>
                            <th>
                                <T>Interval</T>
                            </th>
                            {_hasRotation && (
                                <th>
                                    <T>Speed</T>
                                </th>
                            )}
                            {_hasTilt && (
                                <th>
                                    <T>Tilt</T>
                                </th>
                            )}
                            {_hasLightFactor && (
                                <th>
                                    <T>Light factor</T>
                                </th>
                            )}
                            {_hasTemp && (
                                <th>
                                    <T>Temperature</T>
                                </th>
                            )}
                            <th>
                                <T>Duration</T>
                            </th>
                        </tr>
                    </thead>
                    <tbody id="cycles-body">
                        {this.renderRows(
                            _hasRotation,
                            _hasLightFactor,
                            _hasTilt,
                            _hasTemp,
                        )}
                    </tbody>
                </table>
            </Card>
        );
    }

    private renderRows(
        _hasRotation: boolean,
        _hasLightFactor: boolean,
        _hasTilt: boolean,
        _hasTemp: boolean,
    ) {
        const {cycles, durations} = this.props;

        return cycles.map((cycle, i) => (
            <Cycle
                key={i} // there is no other indicator
                cycle={cycle}
                duration={durations[i]}
                hasRotation={_hasRotation}
                hasLightFactor={_hasLightFactor}
                hasTilt={_hasTilt}
                hasTemp={_hasTemp}
            />
        ));
    }
}

export default Cycles;
